/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinksarchivebody3Inputs */

const en_downloadlinksarchivebody3 = /** @type {(inputs: Downloadlinksarchivebody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The link still leads to the store, but taps are no longer counted. The numbers so far stay visible.`)
};

const de_downloadlinksarchivebody3 = /** @type {(inputs: Downloadlinksarchivebody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Link führt weiter in den Store, Tipps werden aber nicht mehr gezählt. Die bisherigen Zahlen bleiben sichtbar.`)
};

/**
* | output |
* | --- |
* | "The link still leads to the store, but taps are no longer counted. The numbers so far stay visible." |
*
* @param {Downloadlinksarchivebody3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinksarchivebody3 = /** @type {((inputs?: Downloadlinksarchivebody3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinksarchivebody3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinksarchivebody3(inputs)
	return de_downloadlinksarchivebody3(inputs)
});
export { downloadlinksarchivebody3 as "downloadLinksArchiveBody" }